import { render, staticRenderFns } from "./Letterhead.vue?vue&type=template&id=4e6b7df3&scoped=true"
import script from "./Letterhead.vue?vue&type=script&lang=js"
export * from "./Letterhead.vue?vue&type=script&lang=js"
import style0 from "./Letterhead.vue?vue&type=style&index=0&id=4e6b7df3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b7df3",
  null
  
)

export default component.exports